import {useLocation, useNavigate} from 'react-router-dom';
import * as I from 'interfaces';

function useParseURL() {
  const navigate = useNavigate();
  const {pathname, search, state} = useLocation();

  const urlSearchParams = new URLSearchParams(search);
  const siteId = urlSearchParams.get(I.URLParams.site);
  const selectedSites = urlSearchParams.getAll(I.URLParams.selectedSite);
  const cageId = urlSearchParams.get(I.URLParams.cage);
  const plansId: string[] = urlSearchParams.getAll(I.URLParams.plan);
  const planId = plansId[0];
  const comparePlansId: string[] = urlSearchParams.getAll(I.URLParams.comparePlan);

  const comparePlanId1 = comparePlansId[0];
  const comparePlanId2 = comparePlansId[1];
  const language = urlSearchParams.get(I.URLParams.language) as I.SupportedLanguages;
  const runId = urlSearchParams.get(I.URLParams.run);
  const shortTermResolution = urlSearchParams.get(I.URLParams.shortTermResolution) as I.ResolutionEnum | null;
  const overviewTableResolution = urlSearchParams.get(I.URLParams.tableResolution) as I.ResolutionEnum | null;
  const longTermResolution = urlSearchParams.get(I.URLParams.longTermResolution) as I.ResolutionEnum | null;
  const shortTermConcessionChart = urlSearchParams.get(I.URLParams.shortTermConcessionChart) ?? I.ChartTypeEnum.bar;
  const contextCageId = urlSearchParams.get(I.URLParams.contextCageId);
  const filteredActions = urlSearchParams.getAll(I.URLParams.filteredAction) as I.FormSelectionEnum[] | null;

  const newId = urlSearchParams.get(I.URLParams.newId);
  const fullscreen = urlSearchParams.get(I.URLParams.fullscreen);
  const startDate = urlSearchParams.get(I.URLParams.startDate);
  const endDate = urlSearchParams.get(I.URLParams.endDate);

  return {
    navigate,
    pathname,
    search,
    siteId,
    selectedSites,
    cageId,
    plansId,
    planId,
    comparePlanId1,
    comparePlanId2,
    urlSearchParams,
    language,
    runId,
    shortTermResolution: shortTermResolution ?? I.ResolutionEnum.day,
    longTermResolution: longTermResolution ?? I.ResolutionEnum.week,
    shortTermConcessionChart,
    overviewTableResolution: overviewTableResolution ?? I.ResolutionEnum.day,
    contextCageId,
    state,
    filteredActions,
    newId,
    fullscreen,
    startDate,
    endDate,
  };
}

export default useParseURL;
